<template>
    <div style="background: #fff" v-loading="loading">
        <!--banner-->
        <div class="nbanner" v-if="$util.isEmpty(keyword)"> 
            <a :href="item.adv_url?item.adv_url.url:'javascript:void(0)'" :target="item.adv_url?'_blank':''" v-for="item in bannerlist" :key="item.adv_id">
               <img :src="$util.img(item.adv_image)" alt="">
            </a>
            <!-- <img v-if="bannerlist.length<=0" src="@/assets/styles/images/ny3.png" alt=""> -->
        </div>
        <!--主体开始-->
        <div class="nding" v-if="!$util.isEmpty(keyword)">
            <div>
                <p>当前位置：</p>
                <a href="/home">首页</a>&gt; <a href="/shop/shoplist">优质企业</a>&gt; <a href="">{{keyword}}</a>
                <p style="float: right">共找到{{count}}条“{{keyword}}”商家信息</p>
            </div>
        </div>
        <div class="shangjia">
            <div class="fenlei">
            <div class="xia1" style="display: flex;flex-direction: row;justify-content: space-between">
                <ul class="poster-txt xg" style="height: 40px;">
                    <h4>地区</h4>
                    <div>
                        <li><a :class="$util.isEmpty(areacode) ? 'on' : ''" href="javascript:void(0)" @click="changeArea('')">不限</a></li>
                        <li v-for="item in areas" :key="item.id"><a :class="item.id == areacode ? 'on' : ''" href="javascript:void(0)" @click="changeArea(item.id)">{{item.shortname}}</a></li>
                    </div>
                </ul>
                <div class="poster-btn"><a href="javascript:void(0);">展开更多</a></div>
            </div>
            </div>
            <div class="fenlei" style="border: #e5e5e5 1px solid">
                <ul class="sh">
                    <li><a :class="$util.isEmpty(category_id_1) ? 'on' : ''" @click="getChild('')" href="javascript:void(0)">全部</a></li>
                    <li v-for="item in categoryList" :key="item.category_id"><a :class="item.category_id == category_id_1 ? 'on' : ''" @click="getChild(item.category_id)" href="javascript:void(0)">{{item.category_name}}</a></li>
                </ul>
                <div class="xia1">
                    <ul v-for="item in childList" :key="item.category_id">
                        <h4>{{item.category_name}}</h4>
                        <div>
                            <li v-for="i in item.child_list" :key="i.category_id"><a :class="i.category_id == category_id ? 'on' : ''" href="javascript:void(0);" @click="changeType(i.category_id)" >{{i.category_name}}</a></li>
                        </div>
                    </ul>
                </div>
            </div>
            <section class="n_shangjia">
                <div class="w1200">
                    <ul>
                        <li v-for="item in shopList" :key="item.site_id">
                            <div class="img slow"><a :href="'/shop-'+item.site_id" target="_blank"><img alt="" :src="item.avatar ? $util.img(item.avatar) : $util.img(defaultShopImage)"></a></div>
                            <div class="con">
                                <h5><a :href="'/shop-'+item.site_id">{{item.site_name}}</a></h5>
                                <p>{{item.seo_description}}</p>
                                <!-- <h6>种养种植大户</h6> -->
                                <div class="more"><a :href="'/shop-'+item.site_id"><img alt="" src="@/assets/styles/images/right03.png"></a></div>
                            </div>
                        </li>
                    </ul>
                    <div class="clear"></div>
                </div>
                <div class="pages">
                    <div class="Pagination"></div>
                    <!-- <div class="searchPage"> <span class="page-sum">共<strong class="allPage">{{pageCount}}</strong>页</span></div> -->
                </div>
            </section>
        </div>
    </div>
</template>

<script>

import '@/assets/styles/js/jquery.pagination.js';
import { shopList } from "@/api/shop"
import { getArea } from '@/api/address';
import { getMenuList } from '@/api/goods/goodscategory';
import { tree } from '@/api/goods/goodscategory';
import { mapGetters } from "vuex";
import { adList } from "@/api/website";

export default {
    data: () => {
        return {
            loading: false,
            shopList: [],
            pageCount:0,
            page_size:6,
            page:1,
            bannerlist:[],
            areas:[],
            areacode:'',
            category_id:'',
            category_id_1:'',
            categoryList:[],
            childList:[],
            keyword:'',
            count:0
        }
    },

    created() {
        this.keyword = this.$route.query.keyword;
        $(function(){
                $(".poster-btn").click(function(){
                    if ($(this).text() == "展开更多") {
                        $(this).html('<a href="javascript:void(0);">点击收起</a>');
                        $(this).siblings(".poster-txt").removeClass("xg").css("height","auto");
                        $(this).addClass('current-menu').siblings().removeClass('current-menu');
                    }else{
                        $(this).html('<a href="javascript:void(0);">展开更多</a>');
                        $(this).siblings(".poster-txt").addClass("xg").css("height","40px");
                        $(this).removeClass('current-menu').siblings().addClass('current-menu');
                    }
                });
            })
        this.getAreas();
        this.getTrees();
        this.getShopList();
        this.getbannerlist();
    },
    computed: {
        ...mapGetters(["defaultShopImage"])
    },
    methods: {
        getbannerlist() {
                adList({
                    keyword:"PC_QIYE_BANNER"
                }).then(res => {
                    if(res.code == 0) {
                        this.bannerlist = res.data.adv_list.slice(0,1);
                        for (let i = 0; i < this.bannerlist.length; i++) {
                            if (this.bannerlist[i].adv_url) this.bannerlist[i].adv_url = JSON.parse(this.bannerlist[i].adv_url)
                        }
                    }
                })
            },
        getShopList() {
            const params = {
                page_size: this.page_size,
                page: this.page,
                keyword: this.keyword,
                category_id: this.category_id,
                areacode: this.areacode,
            }
            shopList(params || {})
                .then(res => {
                    if(res.code == 0) {
                        this.count = res.data.count;
                        this.pageCount = res.data.page_count;
                        $(".Pagination").pagination(this.pageCount, {
                            callback: this.changepage
                        });
                        this.shopList = res.data.list
                    }
                    this.loading = false
                })
                .catch(err => {
                    this.loading = false
                })
        },
        changepage(page_id) {
                this.loading = true;
                this.page = page_id + 1;
                shopList({
                    page_size: this.page_size,
                    page: this.page,
                    keyword: this.keyword,
                    category_id: this.category_id,
                    areacode: this.areacode
                }).then(res => {
                    if(res.code == 0) {
                        this.shopList = res.data.list;
                        this.loading = false;
                    }
                });
        },
        getAreas() {
                getArea({

                }).then(res => {
                    if(res.code == 0) {
                        this.areas = res.data;
                    }
                })
            },
        getTrees() {
                tree({
                    level:1
                }).then(res => {
                    if(res.code == 0) {
                        this.categoryList = res.data;
                    }
                });
            },
        getChild(id) {
                this.category_id_1 = id;
                this.isshow = false;
                this.category_id = id;
                this.getShopList();
                this.childList = [];
                if(!util.isEmpty(id)) {
                    getMenuList({
                        pid: id
                    }).then(res => {
                        if(res.code == 0) {
                            this.childList = res.data;
                        }
                    });
                }
            },
        changeArea(id) {
                this.areacode = id;
                this.getShopList();
            },
        changeType(id) {
            this.category_id = id;
            this.getShopList();
        }
    },
}
</script>
